import { Languages } from "../../../enums/languages";

const checkPermitStatusModalLang = {
    "modal-title": {
        [Languages.Hebrew]: { default: "בדיקת תוקף תו חניה" },
        [Languages.Arabic]: { default: "التحقق من حالة التصريح" },
        [Languages.English]: { default: "Check Permit Status" }
    },
    "permit-end-date-description": {
        [Languages.Hebrew]: { default: "תוקף התו מסתיים בתאריך:" },
        [Languages.Arabic]: { default: "تنتهي صلاحية التصريح في التاريخ:" },
        [Languages.English]: { default: "The permit expires on:" }
    }
};

export default checkPermitStatusModalLang;